export const etcUrls = {
    getCompanyInformation: "/passenger/company-information/",
    getCompanyWebsiteContent: "/passenger/company-website-content/",
    getStationList: "/passenger/station/",
    getTopRouteList: "/passenger/route?page=1&per_page=",
    getOperators: "/passenger/all-operators/",
    getCompanySummary: "/passenger/company-summary/",
};
export default etcUrls;
